<template>
  <div class="mt-5">
    <div v-if="!selectedStoreName">
      <h2>Select Store Template</h2>
      <p class="mb-5">Select from our library of templates to create your store from.</p>
      <button class="btn btn-primary" @click="openModal">Select Template</button>
    </div>
    <div v-else class="">
      <h2>Selected Template</h2>
      <div class="bg-light rounded-lg p-3 d-flex justify-content-between align-items-center">
        <strong>{{ selectedStoreName }}</strong
        ><button class="btn btn-link ml-2" @click="openModal">Change Template</button>
      </div>
    </div>

    <b-modal
      scrollable
      ref="themes"
      title="Store Templates"
      hide-footer
      modal-class="modal-fullscreen modal-fullscreen--top border-0 rounded-0"
      content-class="border-0 rounded-0"
      body-class="p-3 container-max w-100"
    >
      <StoreTemplateList @select="handleSelect" />
    </b-modal>
  </div>
</template>

<script>
export default {
  name: 'StoreTemplatesModal',
  components: {
    StoreTemplateList: () => import('@mtntop/utils/src/components/StoreTemplateList')
  },
  props: {
    selectedTemplateName: { type: String }
  },
  data() {
    return {
      showModal: false,
      selectedStoreName: this.selectedTemplateName ? this.selectedTemplateName : ''
    };
  },
  methods: {
    openModal() {
      this.$refs.themes.show();
    },
    closeModal() {
      this.$refs.themes.hide();
    },
    handleSelect(store) {
      this.selectedStoreName = store.storeName;
      this.$emit('selectedStore', store);
      this.closeModal();
    }
  }
};
</script>
